import * as _ from 'lodash'
import { required, helpers } from 'vuelidate/lib/validators'
import Api from '@/providers/Api'

/**
 * Model "class" for Company - defines useful field metadata for building and validating forms
 */

export default {
    fields: {
        name: {
            label: 'FIELD_COMPANY_NAME',
            type: 'text',
        },
        contact_name: {
            label: 'FIELD_COMPANY_CONTACT_NAME',
            type: 'text',
        },
        contact_email: {
            label: 'FIELD_COMPANY_CONTACT_EMAIL',
            type: 'text',
        },
        emr_info: {
            label: 'FIELD_COMPANY_EMR_INFO',
            type: 'textarea',
            placeholder: 'FIELD_COMPANY_EMR_PLACEHOLDER',
            description: 'FIELD_COMPANY_EMR_DESCRIPTION',
            validations: { required },
        },
    }
}
